<template>
  <container-data-input-card
      :value="contact"
      :config="config"
      :blocked="block"
      is-single
      can-close-enter
      :saving="saving"
      :error="error"
      @change-data="saveContact($event)"
  >
  </container-data-input-card>
</template>

<script>
import ContainerDataInputCard from "@/components/cards/DataCardInput/ContainerDataInputCard";
import ContactsConfig from "@/pages/Contacts/configs/contacts(Director)";
import {mapActions, mapGetters} from "vuex";
import ContactsController from "@/controllers/ContactsController";

export default {
  name: "ContactDirector",
  components: {ContainerDataInputCard},
  data() {
    return {
      contact: {
        typeContact: 'MAIN'
      },
      saving: false,
      error: null,
      config: ContactsConfig
    }
  },
  computed: {
    block() {
      return false
    },
    ...mapGetters('checkFilled', {get_contact_data: 'get_contact_data'})
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions('checkFilled', {addNewContact: 'addNewContact'}),
    initData() {
      this.saving = true;
      const main = this.get_contact_data?.find(el => el.typeContact === 'MAIN')
      if (this.get_contact_data?.length && main) {
        // console.log(`1111`);
        this.contact = {...this.contact, ...main}
        this.saving = false;
        this.error = null;
        return;
      }
      ContactsController.getOrganizationContact()
          .then(data => {
            // console.log(`2222`);
            // console.log(data);
            const main = data.find(el => el.typeContact === 'MAIN');
            if (main) {
              this.addNewContact(main);
              this.contact = {...this.contact, ...main}
            }
            this.error = null;
          })
          .catch(() => this.error = 'Ошибка получения')
          .finally(() => this.saving = false)
    },
    saveContact(payload) {
      this.saving = true;
      ContactsController.setOrganizationContact(payload)
          .then(data => {
            this.addNewContact(data);
            this.contact = {...this.contact, ...data};
            this.error = null;
          })
          .catch(() => this.error = 'Ошибка сохранения')
          .finally(() => this.saving = false)
    }
  },
}
</script>

<style scoped>

</style>